import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';

const serpApi = createApi({
  reducerPath: 'serp',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['SerpHistory', 'SerpStatus', 'SerpOverview'],
  endpoints: () => ({})
});

export default serpApi;
